import FileText from 'react-feather/dist/icons/file-text.js'
import Users from 'react-feather/dist/icons/users.js'
import AlertCircle from 'react-feather/dist/icons/alert-circle.js'

export default function NotificationLogo (props) {
  switch (props.type) {
  case 1:// New Offer
  case 2:// Edited Offer
  case 4:// Closed Offer
  case 32:// Admin New Offer Answer
  case 64:// Admin Offer Answer Edited
  case 128:// Admin Offer Answer removed
  case 256:// Admin New Offer
    return <FileText/>

  case 8:// Admin New Freelance
  case 16:// Admin Freelance Edited
  case 512:// Admin new Meeting
  case 1024:// Admin New DO
    return <Users/>

  default:
    return <AlertCircle/>
  }
}
